import { typographyConfig } from "./typography.config"

const { sizesMap, colorsMap, lineHeightMap } = typographyConfig

export { sizesMap as typographySizesClassMap }
export { colorsMap as typographyColorsClassMap }
export { lineHeightMap as typographyLineHeightsMap }
export { Typography, type TTypographyProps } from "./typography.component"
export {
    ETypographySize,
    ETypographyTag,
    ETypographyColor,
    ETypographyWeight,
    ETypographyAlignment,
    ETypographyFamily
} from "./typography.types"

export * from "./special-char"
